import React from "react";
import LeaveRequestsListController from "../Controllers/LeaveRequestListController";
import Loader from "../../Components/Loader";
import downArrow from "../../Assets/Icons/chevron-down.png";
import LeaveRequestModal from "../Components/LeaveRequestModal";
import { convertGMTToLocal, getLeaveWeekdays, getLeaveDates, getLeaveDatesWithDays } from "../../Utils/Validation";

const LeaveRequestsListScreen = ({ leaveRequestsList, loading, error, onRefresh }) => {
  const {
    isModalOpen,
    handleAddLeaveRequest,
    handleCloseModal,
    getStatusStyle,
    handleEditLeaveRequest,
    leaveRequestInfo,
    leaveRequestInfoRef,
    OnAddUpdateSuccess,
    currentPage,
    totalPages,
    handlePageChange,
    currentRequests,
    isViewLeaveRequestModalOpen,
    handleViewLeaveRequestClick,
    viewLeaveRequestInfoRef,
    handleCloseViewLeaveRequestModal,
    visiblePages,
    daysExpandedRows, daysToggleExpand,
    datesExpandedRows, datesToggleExpand,
    expandedRows, toggleExpand,
  } = LeaveRequestsListController(onRefresh, leaveRequestsList);

  return (
    <div className="basic-info-container">
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 10, alignItems: "center" }}>
        <h3 style={styles.categoryHeader}>Leave Requests</h3>
        <button className="add-client-button" style={{ paddingLeft: 30, paddingRight: 30 }} onClick={handleAddLeaveRequest}>
          Request Leave
        </button>
      </div>

      <div style={styles.tableWrapper}>
        <table className="tasksScreen-task-table">
          <thead>
            <tr>
              <th style={{ width: "15%" }}>Date</th>
              <th style={{ width: "15%" }}>Day of the Week</th>
              <th style={{ width: "10%" }}>Leave Type</th>
              <th style={{ width: "10%" }}>No. of Days</th>
              <th style={{ width: "20%" }}>Comment</th>
              <th style={{ width: "15%" }}>Status</th>
              <th style={{ width: "15%" }}>Approved/Rejected By</th>
              {/* <th style={{ width: "10%" }}></th> */}
            </tr>
          </thead>

          {currentRequests.length > 0 && (
            <tbody style={{ backgroundColor: "white" }}>
              {currentRequests?.map((request, index) => {
                // const days = getLeaveWeekdays(request?.start_date, request?.end_date);
                // const isExpanded = daysExpandedRows[index];
                const leaveDetails = getLeaveDatesWithDays(request?.start_date, request?.end_date)
                // const leaveDetails = getLeaveDatesWithDays(convertGMTToLocal(request?.start_date,'dd/MM/yyyy'), convertGMTToLocal(request?.end_date,'dd/MM/yyyy'));
                return (
                  <tr key={index}>
                    <td style={styles.tableValue}>
                      {leaveDetails.length <= 2 ? (
                        leaveDetails.map((d) => d.date).join(", ")
                      ) : expandedRows[`${index}-dates`] ? (
                        <>
                          {leaveDetails.map((d) => d.date).join(", ")}{" "}
                          <span className="show-more-less" onClick={() => toggleExpand(`${index}-dates`)}>
                            Show less
                          </span>
                        </>
                      ) : (
                        <>
                          {leaveDetails.slice(0, 2).map((d) => d.date).join(", ")}{" "}
                          <span className="show-more-less" onClick={() => toggleExpand(`${index}-dates`)}>
                            +{leaveDetails.length - 2} More
                          </span>
                        </>
                      )}

                    </td>
                    <td style={styles.tableValue}>
                      {leaveDetails.length <= 2 ? (
                        leaveDetails.map((d) => d.day).join(", ")
                      ) : expandedRows[`${index}-days`] ? (
                        <>
                          {leaveDetails.map((d) => d.day).join(", ")}{" "}
                          <span className="show-more-less" onClick={() => toggleExpand(`${index}-days`)}>
                            Show less
                          </span>
                        </>
                      ) : (
                        <>
                          {leaveDetails.slice(0, 2).map((d) => d.day).join(", ")}{" "}
                          <span className="show-more-less" onClick={() => toggleExpand(`${index}-days`)}>
                            +{leaveDetails.length - 2} More
                          </span>
                        </>
                      )}
                    </td>
                    {/* <td style={styles.tableValue}>{request?.start_date ? convertGMTToLocal(request?.start_date, 'dd/MM/yyyy') : '--'}</td> */}
                    {/* <td style={styles.tableValue}>{days.length <= 2 ? (
                      days.join(", ")
                    ) : isExpanded ? (
                      <>
                        {days.join(", ")}{" "}
                        <span className="show-more-less" onClick={() => daysToggleExpand(index)}>Show less</span>
                      </>
                    ) : (
                      <>
                        {days.slice(0, 2).join(", ")}{" "}
                        <span className="show-more-less" onClick={() => daysToggleExpand(index)}>+{days.length - 2} more</span>
                      </>
                    )}
                    </td> */}
                    <td style={styles.tableValue}>{request?.leave_type_name || '--'}</td>
                    <td style={styles.tableValue}>{(typeof request?.total_days === "number" && !isNaN(request?.total_days)) ? (request?.total_days < 10 ? `0${request?.total_days}` : request?.total_days) : request?.total_days}</td>
                    {/* <td style={styles.tableValue}>{request?.comment ? `${request?.comment?.slice(0, 10)}...` : '--'}</td> */}
                    <td style={styles.tableValue}>
                      {request?.comment ? (
                        request?.comment?.length <= 40 ? ( // Adjust length threshold as needed
                          request?.comment
                        ) : expandedRows[`${index}-comment`] ? (
                          <>
                            {request?.comment}{" "}
                            <span
                              className="show-more-less"
                              onClick={() => toggleExpand(`${index}-comment`)}
                              style={{ color: "#5A55D2", cursor: "pointer" }}
                            >
                              Show less
                            </span>
                          </>
                        ) : (
                          <>
                            {request?.comment.slice(0, 40)}...{" "}
                            <span
                              className="show-more-less"
                              onClick={() => toggleExpand(`${index}-comment`)}
                              style={{ color: "#5A55D2", cursor: "pointer" }}
                            >
                              More
                            </span>
                          </>
                        )
                      ) : (
                        "--"
                      )}
                    </td>
                    <td style={styles.tableValue}>
                      <div
                        style={{
                          display: "inline-block",
                          padding: "5px 10px",
                          borderRadius: "15px",
                          ...getStatusStyle(request?.leave_status_name),
                        }}
                      >
                        {request?.leave_status_name || '--'}
                      </div>
                    </td>
                    <td style={styles.tableValue}>{request?.approved_by_name || '--'}</td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>

        {loading && <Loader loading={loading} color={"var(--primary-loader-color)"} />}
        {error && <div className="list-error-msg">{error}</div>}

        {isModalOpen && <LeaveRequestModal isOpen={isModalOpen} onClose={handleCloseModal} onValueChange={OnAddUpdateSuccess} />}

        <div className="tasksScreen-table-footer">
          <span className="tasksScreen-pagination-info">
            {`${currentPage}-${totalPages} of items`}
          </span>
          <div className="tasksScreen-pagination">
            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
              <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
            </button>

            {visiblePages.map((page) => (
              <button key={page} className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
                {page}
              </button>
            ))}

            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
              <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  categoryHeader: {
    color: "#1F384C",
    fontSize: 28,
    fontFamily: "Roboto Slab",
    fontWeight: 500,
  },
  tableWrapper: {
    overflowX: "auto",
    whiteSpace: "nowrap",
    marginBottom: 50,
  },
  tableValue: {
    color: "#192A3E",
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "12px",
  },
  tableLink: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "12px",
    textDecoration: "underline",
    color: "#5A55D2",
    cursor: "pointer",
  },
  deleteErrorMsg: {
    color: 'red',
  }
};

export default LeaveRequestsListScreen;




